import "./PrimaryButton.css";

const PrimaryButton = ({
    children,
    onClick,
    disabled,
    variant = "primary",
    type = "button"
}) => {

    return (

        <button

            type={type}

            className={`primary-btn ${variant}`}

            disabled={disabled}

            onClick={onClick}

        >

            {children}

        </button>

    );

};

export default PrimaryButton;